export default __webpack_public_path__ + "static/media/leaderboardbonusone.0f7fd5a3.png";